import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import './styles/tailwind.css'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'

// 全局注册 Element Plus，页面中可以直接使用 el-* 组件和消息服务。
createApp(App).use(store).use(router).use(ElementPlus).mount('#app')
